import { Grid } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { connect } from 'formik';
import React from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';

import type { IForm } from 'v2/components/Shared/Content';

import { EChargeType } from '../../classes/Product';

import type { Payments } from '../../classes/Payment';

interface IProps extends IForm<Payments> {}

const Other = (props: Partial<IProps>) => {
  const { values } = props.formik;
  const ShowIfPayments = createShowIf<Payments>();

  return (
    <ShowIfPayments value={values} compare={{ eq: { charge_type: EChargeType.OTHER } }}>
      <Grid item xs={12}>
        <Alert severity='info'>
          <p>O valor minímo no checkout será de R$ 5,00</p>
          <p>Não será habilitado o parcelamento no checkout</p>
        </Alert>
      </Grid>
    </ShowIfPayments>
  );
};

export default connect(Other);
